export enum UserRoles {
  GLOBAL_ADMIN = 'globalAdmin',
  USER = 'user',
}
